var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoGroupchatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info_13px",
    transform: "translate(-549.4 -325.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "information-circle-outline",
    transform: "translate(549.4 325.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M69.9,63.4a6.5,6.5,0,1,1-6.5,6.5A6.507,6.507,0,0,1,69.9,63.4Zm0,11.9a5.4,5.4,0,1,0-5.4-5.4A5.408,5.408,0,0,0,69.9,75.3Z",
    transform: "translate(-63.4 -63.4)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2502",
    "data-name": "Group 2502",
    transform: "translate(5.088 3.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M220.635,223.217a.462.462,0,0,1-.462-.462v-2.432h-.312a.462.462,0,1,1,0-.923h.774a.462.462,0,0,1,.462.462v2.894A.462.462,0,0,1,220.635,223.217Z",
    transform: "translate(-218.954 -217.589)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M209.99,340.323h-2.128a.462.462,0,0,1,0-.923h2.128a.462.462,0,0,1,0,.923Z",
    transform: "translate(-207.4 -334.471)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M222.731,130a.731.731,0,1,0,.731.731A.731.731,0,0,0,222.731,130Z",
    transform: "translate(-221.19 -130)",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGroupchatIcon);
export default __webpack_public_path__ + "static/media/info-groupchat-icon.116cb517639f9f3dcc889653c89cd6f8.svg";
export { ForwardRef as ReactComponent };